import {LitElement} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {query} from "lit/decorators/query.js";
import {SbkForm} from "@/components/form/form";
import "@/components/ch-survey/ch-survey.scss";
import {SbkButton} from "@/components/button/button.ts";
import "@/components/loading-animation/loading-animation"
import {SbkBanner} from "@/components/banner/banner.ts";
import {SbkRadio} from "@/components/radio/radio.ts";
import {SbkCheckbox} from "@/components/checkbox/checkbox.ts";

@customElement('sbk-ch-survey')
export class SbkChSurvey extends LitElement {

    @property({type: Number, attribute: 'survey-id'})
    surveyId: number = 0;

    @query('form')
    _form?: HTMLFormElement

    @query('sbk-banner')
    _resultContainer!: SbkBanner

    @query('sbk-button')
    _submitButton!: SbkButton

    connectedCallback() {
        super.connectedCallback();
        this._form && this._form.addEventListener('submit', (e) => {
            e.preventDefault()
            this._onSubmit();
        });
    }

    protected createRenderRoot() {
        return this
    }

    private _onSubmit() {
        if (!this._form) {
            return
        }
        const invalidElements = SbkForm.validate(this._form);
        if (invalidElements.length) {
            const firstInvalidElement = invalidElements[0];
            firstInvalidElement.focus({preventScroll: true});
            firstInvalidElement.scrollIntoView({behavior: 'smooth'});
        } else {
            const answers: FormDataEntryValue[] = [];
            const formElement: SbkRadio|SbkCheckbox|null = this._form.querySelector('sbk-radio, sbk-checkbox')
            for (const entry of new FormData(this._form).entries()) {
                if (entry[0] == formElement?.name && entry[1]) {
                    answers.push(entry[1].toString());
                }
            }
            const url = `/?type=3001&tx_mmscontenthub_survey%5Bsurvey%5D=${this.surveyId}&tx_mmscontenthub_survey%5Banswers%5D=${answers.join(',')}`;
            fetch(url, {
                method: this._form.method,
            })
                .then((response) => {
                    return response.text()
                })
                .then(() => {
                    fetch(`/?type=3000&tx_mmscontenthub_survey%5Bsurvey%5D=${this.surveyId}`)
                        .then((response) => {
                            return response.text()
                        })
                        .then((data) => {
                            this.outerHTML = data;
                        })
                })
        }
    }
}
